// extracted by mini-css-extract-plugin
export default {"repeatableFieldRemoveItem":"repeatableFieldRemoveItem---MN_27"};